<div class="heatmap-container">
  <div class="heatmap-flex">
    <div
      class="heatmap-item"
      *ngFor="let heatmapData of config; let i = index"
    >
      <!-- Title for each heatmap (optional) -->
      <h3 class="heatmap-title" *ngIf="heatmapData.title">
        {{ heatmapData.title }}
      </h3>

      <!-- Heatmap container with unique ID -->
      <div
        [id]="'heatmap-' + i"
        class="heatmap-plot"
      ></div>
    </div>
  </div>
</div>
